import styled from './modalemail.module.css'
import { useContext, useEffect, useState } from 'react';
import {AuthContext} from '../../services/global';
import api from '../../services/api';
import {Alerta} from '../../utils/functions';


function ModalEmail(props) {
    const {setIsOpenE} = useContext(AuthContext);
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    
    const [emanfe,setEmanfe] = useState('');
    const [emafin,setEmafin] = useState('');
    const [endalt,setEndalt] = useState('');
    const [emapos,setEmapos] = useState('');
    const [emacom,setEmacom] = useState('');

    
    function closeModal() {
        setIsOpenE(false);
    }

     function GetEmails(){
        api.get(`emails/?cgccli=${cgccli}`)
        .then((response)=>{
           if(!response.data.msg){
               setEmanfe(response.data.emanfe)
               setEmafin(response.data.emafin)
               setEndalt(response.data.endalt)
               setEmapos(response.data.emapos)
               setEmacom(response.data.emacom)
               
               

           }else{
             closeModal();
           }
        }).catch((erro)=>{
            closeModal();
            Alerta('Erro!','Erro de acesso ao servidor!','error');
        })
    }

     function PutEmails(){
         
        let dados ={
                emanfe:emanfe,
                emafin:emafin,
                endalt:endalt,
                emapos:emapos,
                emacom:emacom
        };        
        
        api.put(`emails/?cgccli=${cgccli}`,dados)
        .then((response)=>{
           if(!response.data.errocod){       
        
            closeModal();
            Alerta('Sucesso!','Alteração realizada com sucesso !','success');

           }else{
            closeModal();
            Alerta('Erro!',response.data.errocod,'error');
           }
        }).catch((erro)=>{
            closeModal();
            Alerta('Erro!',erro,'error');
        })
    }


    useEffect(()=>{
      GetEmails();
    },[])


    return (

            <div className={styled.modal}>
                <div className={styled.modalheader}>
                    <a>Outros Emails</a>
                    <div className={styled.cardtitleline}></div>
                </div>
                <div className={styled.modalcontent}>
                    <div className={styled.appmodal}>
                        <div className={styled.div1}>
                            <a>ENVIO DE NFE</a>
                            <input value={emanfe} onChange={(e)=>setEmanfe(e.target.value)}></input>
                        </div>
                        <div className={styled.div1}>
                            <a>FINANCEIRO</a>
                            <input value={emafin} onChange={(e)=>setEmafin(e.target.value)}></input>
                        </div>
                        <div className={styled.div1}>
                            <a>MARKTING</a>
                            <input value={endalt} onChange={(e)=>setEndalt(e.target.value)}></input>
                        </div>
                        <div className={styled.div1}>
                            <a>COMPRAS</a>
                            <input value={emapos} onChange={(e)=>setEmapos(e.target.value)}></input>
                        </div>
                        <div className={styled.div1}>
                            <a>DIRETORIA</a>
                            <input value={emacom} onChange={(e)=>setEmacom(e.target.value)}></input>
                        </div>
                    </div>

                </div>
                <div className={styled.modalfooter} onClick={()=>PutEmails()} >
                    SALVAR
                </div>
            </div>
    )
}

export default ModalEmail;